import { Swiper, SwiperOptions, Navigation } from 'swiper';

Swiper.use([Navigation]);

const SWIPER_OPTIONS: SwiperOptions = {
  loop: true,
  loopedSlides: 8,
  autoHeight: false,
  centeredSlides: true,
  slidesPerView: 5,
  spaceBetween: 43,
  navigation: {
    nextEl: '.swiper__button--next',
    prevEl: '.swiper__button--prev',
  },
};

const sliderInit = (slider: HTMLElement) => {
  // If slider has custom options combine them and create
  // Swiper instance, otherwise create Swiper instance with
  // default options (custom overwrites default)
  const EXTENDED_OPTIONS: SwiperOptions = JSON.parse(decodeURIComponent(slider.getAttribute('data-swiper'))) ?? {};
  const OPTIONS = {...SWIPER_OPTIONS, ...EXTENDED_OPTIONS};

  return new Swiper(slider, OPTIONS);
}
export default sliderInit;
